import type { ReactNode } from 'react';
import { PaginatedDetailCard } from '../../../../components/ui/PaginatedDetailCard';
import { resolveEmergencyContact } from '../../utils/resolveEmployeeFields';
import type { EmergencyContact } from '../../employeeTypes';

type Props = {
  contacts: EmergencyContact[];
  icon: ReactNode;
  iconBg: string;
  title: string;
  t: (k: string) => string;
  stack?: boolean;
  collapsible?: boolean;
  defaultExpanded?: boolean;
};

export function EmergencyContactsCard({
  contacts,
  icon,
  iconBg,
  title,
  t,
  stack,
  collapsible,
  defaultExpanded,
}: Props) {
  return (
    <PaginatedDetailCard
      items={contacts}
      resolveFields={resolveEmergencyContact}
      icon={icon}
      iconBg={iconBg}
      title={title}
      t={t}
      previousLabel={t('employeeDetail.sections.emergencyPrevious')}
      nextLabel={t('employeeDetail.sections.emergencyNext')}
      stack={stack}
      collapsible={collapsible}
      defaultExpanded={defaultExpanded}
    />
  );
}
